export default "__VITE_ASSET__76ee85e7__"